import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import {
  DataGridPro,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid-pro";

import { AddIcon } from "../../components/icons";

import {
  useDispatch,
  adminActions,
  useSelector,
  adminSelectors,
} from "../../state";
import AdminPages from ".";
import { USER_AGENCY_COLUMNS as columns } from "../../constants/tables";

import { useStyles } from "./UserAgencyPage.styles";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport />
    </GridToolbarContainer>
  );
}

export default function UserAgencyPage() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const agencies = useSelector(adminSelectors.user_agencies);
  const [pageSize, setPageSize] = React.useState(25);
  useEffect(() => {
    dispatch(adminActions.getUserAgency());
    dispatch(adminActions.setPageTitle("User Agencies"));
  }, [dispatch]);

  return (
    <div className={classes.page}>
      <div className={classes.topArea}>
        <Link className={classes.link} to={AdminPages.createUserAgency.path}>
          <Button variant="outlined" color="primary">
            <AddIcon /> Add User Agency
          </Button>
        </Link>
      </div>

      <DataGridPro
        rows={agencies}
        columns={columns}
        pagination
        rowsPerPageOptions={[10, 25, 50, 100, 250]}
        pageSize={pageSize}
        getRowId={(row: any) =>
          row.email + row.agency + row.referral_token + row.role + row.id
        }
        onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
        components={{
          Toolbar: CustomToolbar,
        }}
      />
    </div>
  );
}
